var paragraph_default = {
  "fontElementMap": "R3UXu",
  "elementSpacing": "dz0Tw",
  "text": "-To8t dz0Tw",
  "child": "_9Xqr2"
};
export {
  paragraph_default as default
};
//# sourceMappingURL=paragraph-scss.js.map
